import React, {Component} from 'react';
import {connect} from 'react-redux';

import { t, dt } from 'l10n';

import Loading from 'components/Loading';

import '../../sass/member/MemberMessageList.scss';

import MessageDialogItem from './MessageDialogItem';

import { sendMemberMessageToDialog } from 'reducers/memberMessageDialog';

class MessageDialogConversation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            messageText: "",
            startDialog: false,
            pendingSend: false,
        };
    }

    componentDidMount() {
        this.scrollToBottom();
    }

    componentDidUpdate() {
        const { startDialog } = this.state;

        if(!startDialog) {
            this.scrollToBottom();
            this.setState({startDialog: true});
        }
    }

    sendMessage() {
        const { messageText } = this.state;
        const { recipient, dispatch } = this.props;

        const reducerParams = {
            recipient_id: recipient.user.id,
            message: messageText.trim(),
        };

        this.setState({pendingSend: true});

        let action = sendMemberMessageToDialog(reducerParams);

        dispatch(action);

        action.promise
            .then(() => {
                this.setState({
                    messageText: "", 
                    pendingSend: false
                });
                this.scrollToBottom();
            })
            .catch((e) => this.setState({pendingSend: false}))

    }

    changeMessageText(e) { this.setState({messageText: e.target.value}); }

    scrollToBottom() { window.scrollTo(0 , this.scrollarea.scrollHeight); }

    onKeyPressed(e) { e.ctrlKey && e.keyCode == 13 ? this.sendMessage() : false; }

    messageListItem(){
        const { 
            messageList,
            messageError,
            readNewMessage,
        } = this.props;

        let readyList = messageList.length ? messageList.map((item, key) =>
            <MessageDialogItem
                key={key}
                item={item}
                readNewMessage={readNewMessage}
            />
        ) : <div className="empty-list">
                <p>{t('No messages')}</p>
                <p>{t(`${messageError}`)}</p>
            </div>;

        messageList.length && messageError ? readyList.push(            
            <MessageDialogItem
                key="error"
                messageError={messageError}
            />
        ) : null;

        return readyList;
    }

    render() {
        const {
            pendingSend,
            messageText,
        } = this.state;

        const {unRead, positionBottom, recipient: {blacklistedMe, user}} = this.props;

        const checkMessageText = messageText.trim().length > 0;

        return (
            <div className="list-message">
                <div className="message-block">
                    <div className="message" onKeyDown={(e) => checkMessageText && !pendingSend ? this.onKeyPressed(e) : false}>
                        <textarea 
                            readOnly={pendingSend}
                            value={messageText}
                            disabled={blacklistedMe}
                            placeholder={blacklistedMe ? dt('messages', 'Sorry, you\'re blocked by %1.', user.nick) : t('Enter your message')}
                            onChange={(e) => this.changeMessageText(e)} />
                        {!checkMessageText || pendingSend ? 
                            pendingSend ? 
                                <div className="send-loader"><Loading /></div> : 
                                <input type="submit" value={t('Send')} className="send-disabled" disabled/>
                            :
                        <input type="submit" value={t('Send')} onClick={() => this.sendMessage() } />}
                    </div>
                </div>
                <div className="content">
                    <div className="scrollarea" ref={el => this.scrollarea = el}>
                        {this.messageListItem()}
                        <div className={`bottom-down ${unRead && !positionBottom ? 'show' : ''}`}>
                            <div className="background" onClick={() => this.scrollToBottom()}>
                                <div>
                                    <span className="icon"></span>
                                    <p>{t('New message')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
    }), 
    null
)(MessageDialogConversation);


// WEBPACK FOOTER //
// ./src/components/message/MessageDialogConversation.js